import { Component, OnInit, Input, forwardRef, OnChanges, Output, EventEmitter } from '@angular/core';
declare var $: any;
import {
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { BotService } from 'src/app/bots/bot.service';

@Component({
  selector: 'app-autocomplete1',
  templateUrl: './autocomplete1.component.html',
  styleUrls: ['./autocomplete1.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteComponent1),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AutocompleteComponent1),
      multi: true,
    },
  ],
})
export class AutocompleteComponent1 implements OnInit, OnChanges {

  @Input() dropdownId: string;
  @Input() availableTags: Array<Object>;
  @Input() placeholder: String;
  @Input() multiple: Boolean;
  @Input() refresh: Boolean;
  @Output() selected = new EventEmitter<any>();

  countryList:any=[];
  stateList:any=[];
  cityList:any=[];
  customForm: FormGroup;
  onChanged: any = () => {};
  onTouched: any = () => {};

  constructor( fb: FormBuilder, private botService: BotService ) {
    this.customForm = fb.group({
      customControl: [null],
    });
  }

  writeValue(obj: any): void {
    this.customForm.get('customControl').setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(_: FormGroup) {
    return this.customForm.valid ? null : { customForm: { valid: true } };
  }

  ngOnInit(): void { }

  ngOnChanges() {
      const ref = this;
      let CheckedRadio="";
      setTimeout(() => {
        $( "#"+ref.dropdownId )
          .on( "keydown", function( event ) {
            if ( event.keyCode === $.ui.keyCode.TAB && $( ref ).autocomplete( "instance" ) && $( ref ).autocomplete( "instance" ).menu.active ) {
              event.preventDefault();
            } else if ( event.keyCode === $.ui.keyCode.BACKSPACE ) {
              if(!ref.multiple) $( "#"+ref.dropdownId ).val('');
              console.log(event.target.value, $.ui, $( "#"+ref.dropdownId ).val());
            }
          }).autocomplete({
            minLength: 0,
            source: function( request, response ) {
              response($.map(ref.availableTags, function (obj, key) {
                var name = obj.name.toUpperCase();
                if(name.indexOf(ref.extractLast(request.term.toUpperCase())) >  -1) {	
                  return {
                    name: obj.name,
                    checked: obj.checked,
                    code: obj.code
                  }
                }
              }))
            },
            select: function( event, ui ) {
              if(ref.multiple) {
                if(ui.item.checked) {
                  this.value = this.value.replace(ui.item.code, '');
                  const terms = ref.split( this.value );
                  this.value = terms.filter(x => x != '').join(', ');
                } else {
                  var terms = ref.split( this.value );
                  terms.pop();
                  terms.push( ui.item.code );
                  terms.push( "" );
                  this.value = terms.join( ", " );
                }
                ui.item.checked = !ui.item.checked;
              } else {
                const terms = ui.item.code;
                this.value = ui.item.code;
                ui.item.checked = true;
                CheckedRadio = terms;
              }
              ref.onChanged(this.value);
              ref.onTouched();
              ref.selected.emit(ui.item);
              return false;
            }
          }).autocomplete( "instance" )._renderItem = function( ul, item ) {
            setTimeout(() => {
              ul[0].style.setProperty('clientWidth', document.getElementById('country0').clientWidth+'px', 'important');
              ul[0].style.setProperty('width', document.getElementById('country0').clientWidth+'px', 'important');
            });
            let a, className;
            if(ref.multiple) {
              a = 'checkbox';
              className = 'pointer default-check';
            }
            else {
              a = 'radio';
              className = 'pointer default-radio-btn';
            }
           if(a=='radio' && item.name == CheckedRadio){
              return $( "<li style='cursor:pointer;'>" )
              .append( "<div><input type='"+a+"' class='"+className+"' checked value="+item.code+"><span class='px-2'>" + item.name + "</span></div>" )
              .appendTo( ul );
            }
            else if(a=='radio' && item.name != CheckedRadio){
              return $( "<li style='cursor:pointer;'>" )
              .append( "<div><input type='"+a+"' class='"+className+"' value="+item.code+"><span class='px-2'>" + item.name + "</span></div>" )
              .appendTo( ul );
            }
            else if(a=='checkbox' && item.checked){
              return $( "<li style='cursor:pointer;'>" )
              .append( "<div><input type='"+a+"' class='"+className+"' checked value="+item.code+"><span class='px-2'>" + item.name + "</span></div>" )
              .appendTo( ul );
            }
            else if(a=='checkbox'){
              return $( "<li style='cursor:pointer;'>" )
              .append( "<div><input type='"+a+"' class='"+className+"' value="+item.code+"><span class='px-2'>" + item.name + "</span></div>" )
              .appendTo( ul );
            }
        };
      }, 300);
  }

  split( val ) {
    return val.split( /,\s*/ );
  }

  extractLast( term ) {
    return this.split( term ).pop();
  }

  extractFirst( term ) {
    return this.split( term ).shift();
  }

  showOptions() {
    $( "#"+this.dropdownId ).autocomplete("search", "");
  }
}
